import React, { ReactElement, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { getCalculatorScript, loadScript, loadStyle } from '../../lib/assetLoader';
import { GTM_ACTION } from '../../lib/constant';

import dynamic from 'next/dynamic';

const Calculator = (props) => {
  const calcRef = useRef<HTMLFormElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  const callbackFunc = (entries) => {
    const [entry] = entries;
    setIsVisible(entry.isIntersecting);
  }

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 1.0
  }

  useEffect(() => {
    if (!isVisible) {
      const observer = new IntersectionObserver(callbackFunc, options);
      if (calcRef.current) observer.observe(calcRef.current);

      return (() => {
        if (calcRef.current) observer.unobserve(calcRef.current);
      })
    }
  }, [isVisible, calcRef, options])

  useEffect(() => {
    if (window && !window.openLeadForm) {
      const node = document.createElement('div');
      window.openLeadForm = (category) => {
        document.body.appendChild(node);
        const PopupContent = () => {
          const calculatorPopupData = {
            category: category,
            category_value: category,
            useTimer: false,
            isOpen: true,
            gtmAction: GTM_ACTION.CALCULATOR,
          };
          const LeadFormModal = dynamic(() => import('../modal/LeadFormModal/LeadFormModal'));
          return <LeadFormModal popupData={calculatorPopupData} closePopup={() => { }} />;
        };

        /**
         * TODO: use new rendering element
         * https://legacy.reactjs.org/docs/rendering-elements.html
        */
        ReactDOM.render(<PopupContent /> as any, node);
      };
    }
  });

  const runCalculatorConfig = (config, id) => {
    new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.text = config;
      script.defer = true;
      script.id = `calculator-config-${id}`;

      document.head.appendChild(script);
      script.onload = function () {
        resolve();
      };
      script.onerror = function () {
        reject()
      }
    });
  };

  if (isVisible) {
    runCalculatorConfig(props.config, props.id);
    if (props.queue === props.total) {
      const ids = props.ids.join(',');
      getCalculatorScript(ids, props.slug).then((data) => {
        if (data && data.length) {
          data.forEach(async (d) => {
            if (d.type === 'css' && d.src) {
              await loadStyle(d);
            }
            if (d.type === 'js' && d.src) {
              await loadScript(d);
            }
          });
        }
      });
    }
  }

  return (
    <form
      id={props.id}
      name={props.name}
      action="?"
      method="post"
      encType="multipart/form-data"
      noValidate
      autoComplete="on"
      ref={calcRef}
    >
      {props.children}
    </form>
  );
};

export default Calculator;
